import { formatInTimeZone } from 'date-fns-tz'

export const HistoryColumns = [
  {
    Header: 'Date',
    width: 180,
    accessor: 'modifiedAt',
    Cell: function _Cell({ value = '' }: { value: string }) {
      const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
      const formatedTime = formatInTimeZone(value, timezone, 'MMM dd, yyyy hh:mm aa')
      return formatedTime
    },
  },
  {
    Header: 'Field',
    accessor: 'field_name',
  },
  {
    Header: 'User',
    accessor: 'userName',
  },
  {
    Header: 'Old value',
    accessor: 'old',
    Cell: function _Cell({ value = '' }: { value: string }) {
      // Check value for datetime in format: yyyy-mm-ddThh:mm:ss.ssssss+hh:mm
      const dateRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:[+-]\d{2}:\d{2})?$/

      if (dateRegex.test(value)) {
        const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
        const formatedTime = formatInTimeZone(value, timezone, 'MMM dd, yyyy hh:mm aa')
        return formatedTime
      } else if (value) {
        return value?.toString()
      } else {
        return ''
      }
    },
  },
  {
    Header: 'New value',
    accessor: 'new',
    Cell: function _Cell({ value = '' }: { value: string }) {
      // Check value for datetime in format: yyyy-mm-ddThh:mm:ss.ssssss+hh:mm
      const dateRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:[+-]\d{2}:\d{2})?$/

      if (dateRegex.test(value)) {
        const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
        const formatedTime = formatInTimeZone(value, timezone, 'MMM dd, yyyy hh:mm aa')
        return formatedTime
      } else if (value) {
        return value?.toString()
      } else {
        return ''
      }
    },
  },
]
